import React, { useState } from "react";
import axios from "axios";

const EmployeeSection = () => {
  const [formData, setFormData] = useState({
    facultyName: "",
    facultyEmail: "",
    facultyPassword: "",
    employeeNo: "",
    mobileNo: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post(
        "https://admin.stipsredu.in/api/faculty",
        formData
      );

      alert("Faculty Account Created Successfully!");

      // Reset form
      setFormData({
        facultyName: "",
        facultyEmail: "",
        facultyPassword: "",
         employeeNo: "",
    mobileNo: "",
      });

    } catch (error) {
      alert(error.response?.data?.message || "Error creating account");
    }
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">
        Create Employee Account
      </h2>

      <form
        onSubmit={handleSubmit}
        className="space-y-4 bg-white p-6 rounded-xl shadow-md"
      >
        <input
          type="text"
          name="facultyName"
          value={formData.facultyName}
          onChange={handleChange}
          placeholder="Full Name"
          className="w-full p-3 border rounded-lg"
          required
        />

        <input
          type="email"
          name="facultyEmail"
          value={formData.facultyEmail}
          onChange={handleChange}
          placeholder="Email"
          className="w-full p-3 border rounded-lg"
          required
        />
        <input
          type="number"
          name="employeeNo"
          value={formData.employeeNo}
          onChange={handleChange}
          placeholder="Employee Number"
          className="w-full p-3 border rounded-lg"
          required
        />
        <input
          type="number"
          name="mobileNo"
          value={formData.mobileNo}
          onChange={handleChange}
          placeholder="Mobile Number"
          className="w-full p-3 border rounded-lg"
          required
        />

        <input
          type="password"
          name="facultyPassword"
          value={formData.facultyPassword}
          onChange={handleChange}
          placeholder="Password"
          className="w-full p-3 border rounded-lg"
          required
        />

        <button
          type="submit"
          className="bg-green-600 text-white px-6 py-2 rounded-lg"
        >
          Create Account
        </button>
      </form>
    </div>
  );
};

export default EmployeeSection;